import { LazyImport, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "NotificationDiagnostics" */ './lazyIndex');
});
export var lazyInitializeNotificationDiagnostics = new LazyImport(lazyModule, function (m) { return m.initializeNotificationDiagnostics; });
//# sourceMappingURL=index.js.map